import { render, staticRenderFns } from "./Credenciamento.vue?vue&type=template&id=53b6c92c&scoped=true"
import script from "./Credenciamento.vue?vue&type=script&lang=js"
export * from "./Credenciamento.vue?vue&type=script&lang=js"
import style0 from "./Credenciamento.vue?vue&type=style&index=0&id=53b6c92c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b6c92c",
  null
  
)

export default component.exports